"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_RANGE_OPTIONS = void 0;

var DATE_RANGE_OPTIONS = function DATE_RANGE_OPTIONS(i18n) {
  return [{
    text: i18n.t('dateRange.today'),
    onClick: function onClick(picker) {
      var start = new Date();
      var end = new Date();
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.yesterday'),
    onClick: function onClick(picker) {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.last7'),
    onClick: function onClick(picker) {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.last30'),
    onClick: function onClick(picker) {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.last60'),
    onClick: function onClick(picker) {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.last90'),
    onClick: function onClick(picker) {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.last180'),
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.thisMonth'),
    onClick: function onClick(picker) {
      var today = new Date();
      var start = new Date(today.getFullYear(), today.getMonth(), 1);
      var end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: i18n.t('dateRange.lastMonth'),
    onClick: function onClick(picker) {
      var today = new Date();
      var start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      var end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 59);
      picker.$emit('pick', [start, end]);
    }
  }];
};

exports.DATE_RANGE_OPTIONS = DATE_RANGE_OPTIONS;